import React, { useState, useEffect } from "react";
import "./fukpage.css";
import { Link } from "react-router-dom";
import { baseRequest } from "../../axiosconfig";

const cards = [
  {
    title: "Liste poslovnih procesa",
    description: "Popis poslovnih procesa po organizacionim jedinicama.",
    url: "/admin/poslovni-procesi",
  },
  {
    title: "Mape procesa",
    description: "Mape procesa sa procedurama i dijagramima toka.",
    url: "/admin/mape-procesa",
  },
  {
    title: "Formulari rizika",
    description: "Identifikacija i procena rizika.",
    url: "/admin/formulari-rizika",
  },
  {
    title: "Registri rizika",
    description: "Jedinstven pregled svih rizika i kontrola.",
    url: "/admin/registri-rizika",
  },
  {
    title: "Registar kontrolnih aktivnosti",
    description: "Pregled svih kontrola iz procesa i formulara rizika.",
    url: "/admin/registar-kontrola",
  },
  {
    title: "Akcioni planovi",
    description: "Praćenje mera, zadataka i rokova.",
    url: "/admin/akcioni-planovi",
  },
  {
    title: "Upitnik za samoprocenu",
    description: "Godišnja samoprocena sistema FUK.",
    url: "/admin/samoprocena",
  },
  {
    title: "Godišnji izveštaj o sistemu FUK",
    description: "Rezime samoprocene i statistika sistema.",
    url: "/admin/godisnji-izvestaj",
  },
  {
    title: "Izveštaji",
    description: "Izveštaji po zahtevu rukovodstva.",
    url: "/admin/izvestaji",
  },
];

function FukPage(props) {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    baseRequest
      .get(`/annual_report/${new Date().getFullYear()}`)
      .then((res) => setStats(res.data.stats))
      .catch(() => setStats(null));
  }, []);

  return (
    <div className="admin-page-child-wrapper fuk-page">
      <h2>FINANSIJSKO UPRAVLJANJE I KONTROLA</h2>

      {stats && (
        <div className="fuk-page-stats">
          <div className="fuk-page-stat">
            <span className="fuk-page-stat-number">{stats.process_lists_count}</span>
            <span>poslovnih procesa</span>
          </div>
          <div className="fuk-page-stat">
            <span className="fuk-page-stat-number">{stats.procedures_count}</span>
            <span>procedura</span>
          </div>
          <div className="fuk-page-stat">
            <span className="fuk-page-stat-number">{stats.risks_total}</span>
            <span>identifikovanih rizika</span>
          </div>
          <div className="fuk-page-stat">
            <span className="fuk-page-stat-number">{stats.measures_total}</span>
            <span>mera za upravljanje rizicima</span>
          </div>
        </div>
      )}

      <div className="fuk-page-cards">
        {cards.map((card) => (
          <Link key={card.url} to={card.url} className="fuk-page-card">
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default FukPage;
